module.exports = __webpack_public_path__ + "static/img/-s-3.e5ec315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/-s-3.png
// module id = Oza4
// module chunks = 0